<template>
  <div class="xbb">
    <bonus-progress
      v-if="xbbBonus.activity"
      class="xbb_progress"
      v-bind="progressData"
      @open-dialog="openDialog"/>
    <div
      v-if="dialog.visible"
      class="flex items-center fullscreen xbb_dialog">
      <bonus-dialog-guest />
    </div>
  </div>
</template>

<script>
// https://github.com/pladaria/reconnecting-websocket#readme
import ReconnectingWebSocket from 'reconnecting-websocket'

import { mapState } from 'vuex'
import BonusProgress from './components/BonusProgress'
import BonusDialogGuest from './components/BonusDialogGuest'
import { missionType } from './utils'

export default {
  name: 'Guest',
  components: {
    BonusProgress,
    BonusDialogGuest
  },
  props: {
    player: {
      type: Object,
      default: null
    },
    playingEvent: {
      type: Function,
      default: () => {
        return () => { }
      }
    },
    isDestroy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // WebSocket
      ws: null,
      // Dialog
      dialog: {
        visible: false
      },
      progressData: {
        status: 'PLAY',
        timer: false,
        progress: 0,
        times: 0,
        amount: 0
      }
    }
  },
  computed: {
    ...mapState({
      xbbBonus: state => state.xbbBonus
    })
  },
  mounted () {
    if (this.xbbBonus.activity) {
      this.init()
    }
    this.hijackPlaying()
  },
  beforeDestroy () {
    this.ws.close()
  },
  methods: {
    init () {
      const { domain, userid, cid, wsUrl } = this.xbbBonus
      this.ws = new ReconnectingWebSocket(`${wsUrl}?domain=${domain}&userid=${userid}&cid=${cid}`, [], {
        maxRetries: 10, // maximum number of retries
        maxReconnectionDelay: 3000,
        minReconnectionDelay: 3000
      })

      this.ws.onopen = (event) => {
        console.log('ws onopen')
      }

      this.ws.onclose = (event) => {
        console.log('ws close reason:', event.reason)
        if (event.reason === 'NO ACTIVITY') return this.closeWs()
        this.progressData.status = 'RECONNECT'
      }

      this.ws.onmessage = (event) => {
        const data = JSON.parse(event.data)
        let status = 'CLOSE'
        switch (data.Status) {
          case 'OPEN':
            this.progressHandler(data, { timer: false, status: 'PLAY' })
            break
          case 'FULL':
            this.progressHandler(data, { timer: false, status: 'CLOSE' })
            break
          case 'WAIT':
            status = 'CLOSE'
            if (data.Mession && data.Mession.ActionType === missionType.finish) {
              status = 'NEXT'
            }

            this.progressHandler(data, { timer: false, status })
            break
          case 'NOACTIVE':
            this.closeWs()
            break
        }
      }
    },
    progressHandler (data, { timer, status }) {
      this.progressData = {
        status: status,
        progress: data.SyncSeconds,
        timer,
        times: data.CueTimes,
        amount: Number(data.Active.MinAmout).toFixed(2)
      }
    },
    openDialog () {
      this.player.pause()
      this.dialog.visible = true
    },
    // 劫持playing函數, 使事件能夠解耦
    hijackPlaying () {
      const parentPlaying = this.playingEvent
      this.$emit('update:playing-event', () => {
        parentPlaying()
        this.openDialog()
      })
    },
    closeWs () {
      this.$emit('update:isDestroy', true)
    }
  }
}
</script>

<style scoped>
.xbb_progress {
  position: absolute;
  top: 25%;
  right: 0;
}

.xbb_dialog {
  padding: 24px;
  background: rgba(0, 0, 0, 0.4);
}

.fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 6000;
  max-width: 100vw;
  max-height: 100vh;
  padding-top: 75px;
  overflow: auto;
  border-radius: 0 !important;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.items-center {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/Guest.vue